export default __webpack_public_path__ + "static/media/AvLogo.d756b623.png";